import useTranslation from "next-translate/useTranslation";
import { updateSetting, useSettings } from "../../redux/settings";
import styles from "./styles/Settings.module.css";
import pieceStyles from "@/chessBoard/components/Piece.module.css";
import { ChessSets } from "@chesshotel/constants";

function Stanuty() {
  return (
    <div className="relative flex overflow-hidden rounded md:w-64">
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bR} `}
        style={{
          transform: `translate(0%, 0%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bN} `}
        style={{
          transform: `translate(100%, 0%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bB} `}
        style={{
          transform: `translate(200%, 0%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bQ} `}
        style={{
          transform: `translate(300%, 0%)`,
        }}
      ></div>

      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bP} `}
        style={{
          transform: `translate(0%, 100%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bP} `}
        style={{
          transform: `translate(100%, 100%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bP} `}
        style={{
          transform: `translate(200%, 100%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.staunty_bP} `}
        style={{
          transform: `translate(300%, 100%)`,
        }}
      ></div>

      <svg
        width="100%"
        viewBox="0 0 400 300"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Light" fill="#EDD6B0">
          <rect x="0" y="0" width="100" height="100" />
          <rect x="200" y="0" width="100" height="100" />
          <rect x="100" y="100" width="100" height="100" />
          <rect x="300" y="100" width="100" height="100" />
          <rect x="0" y="200" width="100" height="100" />
          <rect x="200" y="200" width="100" height="100" />
        </g>

        <g id="Dark" fill="#B98761">
          <rect x="100" y="0" width="100" height="100" />
          <rect x="300" y="0" width="100" height="100" />
          <rect x="0" y="100" width="100" height="100" />
          <rect x="200" y="100" width="100" height="100" />
          <rect x="100" y="200" width="100" height="100" />
          <rect x="300" y="200" width="100" height="100" />
        </g>
      </svg>
    </div>
  );
}

function ChessHotel() {
  return (
    <div className="relative flex overflow-hidden border border-gray-200 rounded md:w-64">
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bR} `}
        style={{
          transform: `translate(0%, 0%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bN} `}
        style={{
          transform: `translate(100%, 0%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bB} `}
        style={{
          transform: `translate(200%, 0%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bQ} `}
        style={{
          transform: `translate(300%, 0%)`,
        }}
      ></div>

      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bP} `}
        style={{
          transform: `translate(0%, 100%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bP} `}
        style={{
          transform: `translate(100%, 100%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bP} `}
        style={{
          transform: `translate(200%, 100%)`,
        }}
      ></div>
      <div
        className={`${pieceStyles.settings_piece}  ${pieceStyles.chesshotel_bP} `}
        style={{
          transform: `translate(300%, 100%)`,
        }}
      ></div>

      <svg
        width="100%"
        viewBox="0 0 400 300"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Light" fill="#f6f6f6">
          <rect x="0" y="0" width="100" height="100" />
          <rect x="200" y="0" width="100" height="100" />
          <rect x="100" y="100" width="100" height="100" />
          <rect x="300" y="100" width="100" height="100" />
          <rect x="0" y="200" width="100" height="100" />
          <rect x="200" y="200" width="100" height="100" />
        </g>

        <g id="Dark" fill="#ac9c8d">
          <rect x="100" y="0" width="100" height="100" />
          <rect x="300" y="0" width="100" height="100" />
          <rect x="0" y="100" width="100" height="100" />
          <rect x="200" y="100" width="100" height="100" />
          <rect x="100" y="200" width="100" height="100" />
          <rect x="300" y="200" width="100" height="100" />
        </g>
      </svg>
    </div>
  );
}

export default function ChessSet() {
  const { t: settingsT } = useTranslation("auth");
  const { chessSet } = useSettings();

  return (
    <div className={styles.body}>
      <div className={styles.title}>{settingsT("Chess sets")}</div>
      <div className="flex flex-col gap-8 md:flex-row">
        <div>
          <select
            value={chessSet}
            onChange={(e) => {
              updateSetting("chessSet", e.target.value);
            }}
            className="md:w-64"
          >
            <option value={ChessSets.CHESSHOTEL}>Chess Hotel</option>
            <option value={ChessSets.STAUNTY}>Staunty</option>
          </select>
        </div>

        {chessSet === ChessSets.CHESSHOTEL ? <ChessHotel /> : <Stanuty />}
      </div>
    </div>
  );
}
